import {
  QUICK_FILTER_UNCONFIRMED_APPOINTMENTS_TYPE,
  QUICK_FILTER_OPPORTUNITY_TYPE,
  QUICK_FILTER_INCOMPLETE_TYPE,
  APPOINTMENT_STATUS_UNCONFIRMED,
  QUICK_FILTER_CANCELED_APPOINTMENTS,
  APPOINTMENT_STATUS_CANCELED,
  VISIBLE_STATUSES_CODES,
  NON_FINAL_STATUSES_CODES,
  APPOINTMENT_STATUS_RESCHEDULED,
  QUICK_FILTER_DRAFT_APPOINTMENTS,
  APPOINTMENT_STATUS_DRAFT,
} from "constants/appointments";

import { QuerySearchFilter } from "services/types/appointments.type";

export default function getAppointmentsBaseFilter(
  code: string | number,
  baseFilters: QuerySearchFilter = { status: VISIBLE_STATUSES_CODES }
): QuerySearchFilter {
  switch (code) {
    case QUICK_FILTER_UNCONFIRMED_APPOINTMENTS_TYPE:
      return {
        ...baseFilters,
        status: [APPOINTMENT_STATUS_UNCONFIRMED],
      };
    case QUICK_FILTER_OPPORTUNITY_TYPE:
      return {
        ...baseFilters,
        is_opportunity: true,
      };
    case QUICK_FILTER_INCOMPLETE_TYPE:
      return {
        ...baseFilters,
        status: NON_FINAL_STATUSES_CODES,
        is_completed: false,
      };
    case QUICK_FILTER_CANCELED_APPOINTMENTS:
      return {
        ...baseFilters,
        status: [APPOINTMENT_STATUS_CANCELED, APPOINTMENT_STATUS_RESCHEDULED],
      };

    case QUICK_FILTER_DRAFT_APPOINTMENTS:
      return {
        ...baseFilters,
        status: [APPOINTMENT_STATUS_DRAFT],
      };
    default:
      break;
  }
  return baseFilters;
}
